<template>
  <div class="dashboard-container">
    <div class="dashboard-text">{{production.name}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { localRead } from '@/utils/tools'
export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  data(){
      return{
          production:""
      }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
